/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
import { endpoints } from '../../Constants';
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const transitAnalyticsServices = {
	gateway,
	fetchTransitAnalysisExport,
	// fetchCogsAnalysisGraph,
};

function gateway({ req, method }) {
	switch (method) {
		case 'CHART_DATA':
			return fetchTransitAnalysisGraph({
				req,
			});
		case 'LIST_DATA':
			return fetchTransitAnalysisList({
				req,
			});
		default:
			break;
	}
	return new Promise();
}
function fetchTransitAnalysisGraph({ req }) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(endpoints.TRANSIT_ANALYTICS, requestOptions).then(
		handleResponse
	);
}

function fetchTransitAnalysisList({ req }) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.TRANSIT_ANALYTICS_LIST, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function fetchTransitAnalysisExport({ req }) {
	const { params = {} } = req;
	const url = toQueryStringURL(endpoints.TRANSIT_ANALYTICS_EXPORT, params);
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions);
}

// function mockQAList() {
// 	const mockResponse = {
// 		statusCode: 200,
// 		message: 'Success',
// 		data: [
// 			{
// 				id: 7812,
// 				productName: 'Butter Scotch Cake',
// 				skuType: 'PRODUCT',
// 				amountUsed: 6782,
// 				costCategory: 'Inventory Consumed',
// 			},
// 			{
// 				id: 7813,
// 				productName: 'Butter Scotch Base',
// 				skuType: 'INGREDIENT',
// 				amountUsed: 3082,
// 				costCategory: 'PL',
// 			},
// 			{
// 				id: 7814,
// 				productName: 'Cheese',
// 				skuType: 'INGREDIENT',
// 				amountUsed: 3890,
// 				costCategory: 'Wastage',
// 			},
// 		],
// 	};

// 	return new Promise((resolve) => {
// 		setTimeout(() => {
// 			resolve(mockResponse);
// 		}, 1000);
// 	});
// }

export default transitAnalyticsServices;
